import { render, staticRenderFns } from "./VacationHold.vue?vue&type=template&id=a3766182&scoped=true"
import script from "./VacationHold.vue?vue&type=script&lang=js"
export * from "./VacationHold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3766182",
  null
  
)

export default component.exports